import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, FormGroup, UntypedFormControl } from '@angular/forms';
import { interval, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, tap, delay, takeUntil, map, switchMap, catchError, filter } from 'rxjs/operators';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdersService } from '../../services/orders.service';
import { GlobalsService } from '../../services/globals.service';
import { UsersService } from '../../services/users.service';
import { CustomerService } from '../../services/customer.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PurchasingService } from '../../services/purchasing.service';
import { OmsService } from '../../services/oms.service';
import { ReportsService } from '../../services/reports.service';
import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Subject, Observable } from 'rxjs';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as FileSaver from 'file-saver';
import { Location } from '@angular/common'

import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { PrintService } from 'app/services/print.service';

@Component({
	selector: 'app-canceled-orders',
	templateUrl: './canceled-orders.component.html',
	styleUrls: ['./canceled-orders.component.scss']
})
export class CanceledOrdersComponent implements OnInit, OnChanges {

	
	CHAT_ROOM = 'OrderBoard';

	@ViewChild('purchaseOrderDetails') purchaseOrderDetailsRef: ElementRef;
	@ViewChild('orderStatusView') orderStatusViewRef: ElementRef;
	@ViewChild('popTemplate') popTemplateRef: ElementRef;
	@ViewChild('confirmCancelPoRef') confirmCancelPoRef: ElementRef;
	@ViewChild('confirmCancel') confirmCancel: ElementRef;

	pendingCancelOrderNo: any;
	purchaseOrderLinked: any;


	@ViewChild('mapDiv') mapDivEle: ElementRef;

	@ViewChild('posRecRef') posRecRef: ElementRef;
	

	@Input() customerdata: any = false;
	@Input() item: any = false;
	@Input() orderstatus: any = false;
	@Input() flipfilter: any = false;
	@Output() cart_updated = new EventEmitter < string > ();
	@Output() cancel = new EventEmitter < boolean > ();
	@Output() orderloaded = new EventEmitter < any > ();
	@Output() preorderloaded = new EventEmitter < any > ();
	@Output() orderinvoice = new EventEmitter < any > ();
	@Output() reloadCustomer = new EventEmitter < any > ();

	snoozeForm: UntypedFormGroup;

	searchInput = new UntypedFormControl('');
	statusSearch = new UntypedFormControl('');
	order_status_edit = new UntypedFormControl('');
	searchInputItems = new UntypedFormControl('');
	defaultlocation = new UntypedFormControl('');
	shipvia = new UntypedFormControl('');
	podetails: any = false;
	openorders: any = [];
	customertrans: any = [];
	filteredItems: any = [];
	map: any = false;
	updated_map: any = false;
	markers: any = [false];
	pathlines: any = false;
	isMerging = false;
	selectedPrinted: any = '';
	map_animation: any = google.maps.Animation.DROP;
	fetch_subscribtion: any = false;
	headercolumns: string[] = [
		'orderno',
		'statusname',
		'reason',
		// 'pickprinted',
		//'deliverydate',
		'datecreated',
		//'phoneno',
		'deliverto',
		//'deladd1',
		'ponumber',
		'haspo',
		'shipvia',
		'notes',
		'comments',
		//'transno',
		// 'email',
		//'subtotal',
		'takenby',
		'total',
		'void',

	];

	rechtml: any = false;
	thistran: any = false;

	orderupdates: any = [];
	openOrderData: any = [];
	allopenOrderData: any = [];
	config: any = [];
	pickinglink = '';
	invoicelink = '';
	orderdetails: any = [];
	locations: any = [];
	ispos = '';
	color: any = false;

	itemsearchresults: any = [];
	itemsearch = false;
	order_statuses: any = false;
	user: any = false;
	ref_location: any = false;
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;

	snoozeorder;
	snoozetime;
	loading = false;
	dataSubscription: any = Subscription;

	selectedOrderSource = '';
	selectedCustomerType = '';
	private searchDebounce: any;
	numberofdays = 1;
	issnoozed = false
	initaldate = new Date();
	shipvias: any = [];
	salespeople: any = [];
	salespersonRef = new UntypedFormControl('');
	issalesman: any = false;
	isPosUser: any = false;
	editsallowed: any = {
		discounts: true,
		editar: true,
		editbilling: true,
		editshipping: true,
		editcontact: true,
		editprofile: true,
		editnotes: true,
		takepayment: true,
	}
	orderSources = [
		{ value: '1', viewValue: 'Backoffice' },
		{ value: '2', viewValue: 'POS' },
		{ value: '3', viewValue: 'Salesman' },
		{ value: '4', viewValue: 'Online' }
	];

	printedcount = 0;
	notprintedcount = 0;
	totalcount = 0;
	newInputData = false;
	subscriptionActive = false;
	totalsArray: { title: string;value: number } [] = [];
	askForCancelReason = false;
	customertypes: any = [];

	private defaultReasons = [
		{ id: '1', label: 'Customer Request', code: 'CUSTOMER_REQUEST', requires_notes: '0', sort_order: '1', is_active: '1' },
		{ id: '2', label: 'Out of Stock', code: 'OUT_OF_STOCK', requires_notes: '0', sort_order: '2', is_active: '1' },
		{ id: '3', label: 'Duplicate Order', code: 'DUPLICATE_ORDER', requires_notes: '0', sort_order: '3', is_active: '1' },
		{ id: '4', label: 'Pricing Error', code: 'PRICING_ERROR', requires_notes: '1', sort_order: '4', is_active: '1' },
		{ id: '5', label: 'Fraud Concern', code: 'FRAUD', requires_notes: '1', sort_order: '5', is_active: '1' },
		{ id: '6', label: 'Shipping Delay', code: 'SHIPPING_DELAY', requires_notes: '1', sort_order: '6', is_active: '1' },
		{ id: '7', label: 'Other', code: 'OTHER', requires_notes: '1', sort_order: '99', is_active: '1' }
	];

	predefinedReasons: any = [];

	showReasonError = false;
	cancelReason: any = '';
	cancelNotes: any = '';

	pendingCancelReason = '';
	pendingCancelNotes = '';
	pendingCancelTimestamp = '';
	pendingCancelPayload: any = [];
	exportingOrders = false;

	selectedReason: any = '';

	today = new Date();
	fromdate = new Date();
	todateCtrl = new UntypedFormControl(this.today);
	fromdateCtrl = new UntypedFormControl(new Date(this.fromdate.setDate(this.fromdate.getDate() - 3)));

	private currentFilters = {
		searchTerm: '',
		itemSearchTerm: '',
		selectedStatuses: [],
		selectedShipVia: [],
		selectedSalespeople: [],
		selectedOrderSource: '',
		selectedCustomerType: '',
		selectedReason: '',
		selectedPrinted: '' as any,
		warehouse: ''
	};

	// Unified filtering method that combines all filters
	applyAllFilters(): void {
		let filteredData = [...this.allopenOrderData];


		// Apply search filter
		if (this.currentFilters.searchTerm) {
			const beforeCount = filteredData.length;
			filteredData = this.globalSearchService.filterItemO(
				filteredData,
				this.currentFilters.searchTerm.trim(),
				'orderno,transno,ponumber,debtorno,deliverto,deliverydate'
			);
			
		}

		// Apply item search filter
		if (this.currentFilters.itemSearchTerm) {
			const beforeCount = filteredData.length;
			const searchdata = filteredData.map((item: any) => ({ ...item.details, 'stkcode': (item.lines.map((i) => i.stkcode)).join('+') }));
			const searchresults = this.globalSearchService.filterItem(
				searchdata, 
				this.currentFilters.itemSearchTerm, 
				'orderno,narrative,stkcode,description,ordervalue'
			);
			const mapped = searchresults.map((i: any) => i.orderno);
			filteredData = filteredData.filter((o: any) => mapped.includes(o.orderno));
			
		}

		// Apply status filter
		if (this.currentFilters.selectedStatuses.length > 0 && !this.currentFilters.selectedStatuses.includes('')) {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(order =>
				this.currentFilters.selectedStatuses.includes(order.orderstatusid)
			);
			
		}

		// Apply ship via filter
		if (this.currentFilters.selectedShipVia.length > 0) {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(item => 
				this.currentFilters.selectedShipVia.includes(item.shipvia)
			);
			
		}

		// Apply salesperson filter
		if (this.currentFilters.selectedSalespeople.length > 0) {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(order => 
				this.currentFilters.selectedSalespeople.includes(order.takenby)
			);
		}

		// Apply order source filter
		if (this.currentFilters.selectedOrderSource) {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(order => 
				order.details.placedfrom === this.currentFilters.selectedOrderSource
			);
			
		}

		if (this.currentFilters.selectedCustomerType) {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(order => 
				order.details.typeid === this.currentFilters.selectedCustomerType
			);
			
		}

		if (this.currentFilters.selectedReason) {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(order => 
				order.details.cancelreason.code === this.currentFilters.selectedReason
			);
			
		}

		// Apply printed filter
		if (this.currentFilters.selectedPrinted !== '') {
			const beforeCount = filteredData.length;
			filteredData = filteredData.filter(order => {
				if (this.currentFilters.selectedPrinted === true) {
					return order.details.printedpackingslip === '1';
				} else if (this.currentFilters.selectedPrinted === false) {
					return order.details.printedpackingslip === '0';
				}
				return true;
			});
			
		}

		// Update the table data
		this.openOrderData = filteredData;
		this.openorders = new MatTableDataSource(filteredData);
		this.openorders.sort = this.sort;
		this.openorders.paginator = this.paginator;

		// Special handling for department 3 users
		if (this.user?.user?.department === '3' && this.openorders.data.length === 1) {
			this.invoiceOrder(this.openorders.data[0].orderno);
		}
	}

	constructor(private printService: PrintService, private usersService: UsersService, private omsService: OmsService, private formBuilder: UntypedFormBuilder, public purchasingService: PurchasingService, public ordersService: OrdersService, public globalSearchService: GlobalSearchService, public router: Router, public customerService: CustomerService, private location: Location, private globalsService: GlobalsService, private modalService: NgbModal, private reportsService: ReportsService) {

		this.config = this.globalsService.getApiConfig();

		if (this.config.ordercancelreason) {
			this.askForCancelReason = true;
		}

		this.usersService.isPosUser().subscribe((isPOS) => {
			if (isPOS) {
				this.isPosUser = true;
			}
		});



		this.ordersService.getCancelReasons().subscribe((r: any) => {
			if (r && r.success && r.data && Array.isArray(r.data) && r.data.length > 0) {
				this.predefinedReasons = r.data;
			} else {
				this.predefinedReasons = this.defaultReasons;
			}
		}, () => {
			this.predefinedReasons = this.defaultReasons;
		});

		if (this.isPosUser) {
			this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.pickingLink
			this.ispos = 'isPOS=true'
		}
		else {
			this.pickinglink = this.config.apiServer.baseUrl + this.config.apiServer.pickingLink
			this.ispos = 'isPOS=false'
		}
		this.invoicelink = this.config.apiServer.baseUrl + this.config.apiServer.pickingInvoice;

		this.globalSearchService.shipvia.subscribe(r => {
			if (!r) {
				this.globalsService.getShipVia().subscribe((results: any) => {
					this.globalSearchService.shipvia.next(results)
					this.shipvias = results;
				});
			} else {
				this.shipvias = r;
			}
		});

		this.reportsService.getSalesPeople().subscribe((results: any) => {
			this.salespeople = results;
		});

		this.globalsService.getCustomerTypes().subscribe((res:any) => {

			this.customertypes = res;
		})

		this.globalSearchService.user.subscribe(results => {
			//only run if user is definied
			if (this.user) {
				if (results.user.defaultlocation.loccode != this.ref_location) {
					this.defaultlocation.setValue(this.user.user.defaultlocation.loccode);
					this.loadData();
					this.ref_location = false;
				}
			}

			this.user = results
			if (!this.ref_location) {
				this.ref_location = this.user.user.defaultlocation.loccode;
			}


			if (this.user.user.issalesman) {
				this.editsallowed = this.config.salesmanAllowed
				this.issalesman = true;
				this.headercolumns = [
					'orderno',
					'statusname',
					'pickprinted',
					'datecreated',
					'deliverto',
					'ponumber',
					'shipvia',
					'notes',
					'comments',
					'takenby',
					'total',

				];
			}

		});

		this.color = this.globalSearchService.getColor();

	}

	updateRange(start?){
		//don't allow loading until both are selected
		if(start){
			this.todateCtrl.setValue(null);
		}else{
			if(this.fromdateCtrl.value !== null && this.todateCtrl.value !== null && this.fromdateCtrl.value <= this.todateCtrl.value){
				this.dataSubscription.unsubscribe();
				this.subscriptionActive = false;
				this.loading = false;
				
				this.loadData();
			}
		}

		
	}

	

	ngOnInit(): void {

		this.globalSearchService.locations.subscribe(async (results: any) => {
			this.locations = results;
			if (results) {

				this.defaultlocation.setValue(this.user.user.defaultlocation.loccode)
				this.loadData();

			}
		});
		this.snoozeForm = this.formBuilder.group({
			message: ['', Validators.required],
			initials: ['', Validators.required],
			//numberofdays: [1],
			//datepicked: [''],
			// ['', Validators.required],
		});

		this.searchInput.valueChanges.pipe(
			debounceTime(650)
		).subscribe(value => {
			this.onInput(value);
		});


	}

	usePrintConnect() {
		const ep = this.usersService.usePrintConnect();
		this.user.usePrintConnect = ep;
		return ep;
	}

	printCustomerCopy(orderid) {
		this.ordersService.printCustomerCopy(orderid).subscribe((res: any) => {
			const type = 'INVOICE';
			const user = this.user.user.userid;
			const printers = this.usersService.getDevicesByType(user, type);
			if (printers && printers.length && res.base64.length) {
				this.omsService.setNewOrder();
				const customer_copy = res['base64'][1];
				const data = { pdf: customer_copy, user: user, devices: printers }
				this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
					this.omsService.setPrintedOrder();
				})
			}

		})
	}

	filterWarehouse(input: any) {
		this.currentFilters.warehouse = input;
		this.loadData();
	}

	noNewLines(input: any) {
		if (input) {
			return input.replace(/[^\x20-\x7E]/gmi, ' ').trim().replace(/\\n/g, ' ');
		}

		return input;
	}

	getShipVia(idin: any): string {
		if (!this.shipvias || !Array.isArray(this.shipvias)) {
			return 'N/A';
		}

		const filtered = this.shipvias.filter((r: any) => {
			return r.shipper_id === idin;
		})[0];

		return filtered ? filtered.shippername : 'N/A';
	}


	printPacking(orderno: any) {
		this.thistran = { orderno: orderno }; // Store just the order number

		this.ordersService.getOrderPackingList(orderno).subscribe((result: any) => {
			this.rechtml = result.display;

			this.modalService.open(this.posRecRef, { ariaLabelledBy: 'modal-title', size: 'zip' }).result.then((result) => {}, (reason) => {
				this.rechtml = false;
				this.thistran = false;
				this.omsService.setPrintedOrder();
			});
		});

	}


	sendPrint() {

		this.omsService.setNewOrder();
		this.ordersService.getOrderPackingList(this.thistran.orderno).subscribe((result: any) => {
			//this should be done for open order but with multibinpos

			this.globalSearchService.user.subscribe(user => {
				const printers = this.usersService.getDevicesByType(user.user.userid, 'RECEIPT');

				const data = { pdf: result.print, user: user, devices: printers }
				if (printers && printers.length) {

					this.omsService.sendPrintCommand({ data, roomName: 'Printers' }, cb => {
						this.omsService.setPrintedOrder();
					})
				}
			});
		});

	}

	setSnoozeOrder(orderno) {
		this.snoozeorder = orderno;

		const orderdata = this.allopenOrderData.filter(r => {
			return r.orderno = orderno;
		})[0];

		this.issnoozed = (orderdata.snoozed == '1') ? true : false;
		this.modalService.open(this.popTemplateRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result) => {
			this.snoozeorder = false;
		}, (reason) => {

		});
	}

	setSnooze(event: any) {
		this.numberofdays = parseInt(event.target.value);
		this.dateNumberChanged();
	}

	dateNumberChanged() {

		const subject = new Date();
		subject.setDate(subject.getDate());

		const until = new Date();
		until.setDate(until.getDate() + this.numberofdays);

		this.initaldate = new Date(until);
	}

	dateChanged(event) {
		const now = new Date();
		now.setDate(now.getDate());
		const until = new Date(event.value);
		until.setDate(until.getDate());

		const difference = (until.getTime() - now.getTime())
		const days = difference / (1000 * 60 * 60 * 24);
		this.numberofdays = Math.ceil(days);
		this.initaldate = new Date(event.value)
	}

	removeSnooze(orderno: any) {
		const orderdata = this.allopenOrderData.filter(r => {
			return r.orderno = orderno;
		})[0];

		const data = {
			orderno: orderno,
			days: this.numberofdays,
			inititals: this.snoozeForm.controls['initials'].value,
			reason: this.snoozeForm.controls['message'].value,
			user: this.user.user
		};


		this.omsService.sendSnoozeRemove({ data, roomName: this.CHAT_ROOM }, cb => {});

		this.snoozeForm = this.formBuilder.group({
			message: ['', Validators.required],
			initials: ['', Validators.required],
		});

		setTimeout(() => {
			this.loadData();
		}, 500);

	}

	voidPreAuth(orderno: any) {

		const payload = {
			orderno: orderno
		}

		this.ordersService.voidPreAuth(payload).subscribe((r: any) => {
			if (r && r.success) {
				if (r.message?.description) {
					this.globalSearchService.showNotification(r.message?.description, 'success', 'bottom', 'right');
				}
			} else {
				if (r.message?.description) {
					this.globalSearchService.showNotification(r.message?.description, 'danger', 'bottom', 'right');
				}
			}
		})
	}

	// snooze(orderno: any) {

	// 	const orderdata = this.allopenOrderData.filter(r => {
	// 		return r.orderno = orderno;
	// 	})[0];

	// 	// if(this.snoozeForm.status == "INVALID" && orderdata.snoozed != '1') {
	// 	// 	return false;
	// 	// }

	// 	const data = {
	// 		orderno: orderno,
	// 		days: this.numberofdays,
	// 		inititals: this.snoozeForm.controls['initials'].value,
	// 		reason: this.snoozeForm.controls['message'].value,
	// 		user: this.user.user
	// 	};


	// 	this.omsService.sendSnoozeUpdate({ data, roomName: this.CHAT_ROOM }, cb => {

	// 	});

	// 	this.snoozeForm = this.formBuilder.group({
	// 		message: ['', Validators.required],
	// 		initials: ['', Validators.required],
	// 		//numberofdays: [1],
	// 		//datepicked: [''],
	// 		// ['', Validators.required],
	// 	});


	// 	setTimeout(() => {
	// 		this.loadData();
	// 	}, 500);

	// 	this.snoozeorder = false;
	// 	this.issnoozed = false;
	// 	this.modalService.dismissAll();
	// }

	saveStatusUpdate(tran: any) {

		const data = {
			trans: tran,
			type: this.order_status_edit.value,
			user: this.user,
		}

		this.ordersService.updateOrderStatus(data).subscribe((r: any) => {
			if (r.success) {
				tran.edit = false;
				const status = this.order_statuses.filter(s => {
					return s.order_status_id === data.type;
				})[0];
				tran.statusname = status.name;
				tran.orderstatusid = data.type;
				this.order_status_edit.reset();

				this.omsService.sendOrderCheckUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});

			}
		})
	}

	viewStatus(tran: any) {
		this.ordersService.getOrderStatusView(tran.orderno).subscribe((order: any) => {
			this.orderdetails = order

			this.modalService.open(this.orderStatusViewRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result) => {

			}, (reason) => {

			});

			setTimeout(() => {
				if (this.orderdetails.dispatch_details.nextlast) {
					this.drawMap();
				}
			}, 500);
		});
	}

	openModal(content) {
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {}, (reason) => {});
	}

	viewPurchaseOrder(orderno: any) {
		this.purchasingService.getPurchaseOrder(orderno).subscribe((order: any) => {
			this.podetails = order
			this.modalService.open(this.purchaseOrderDetailsRef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {

			});
		});
	}

	search() {
		this.currentFilters.searchTerm = this.searchInput.value || '';
		this.applyAllFilters();
		// this.globalSearchService.blurInputElement(this.searchInput);
	}

	toggleEdit(tran: any) {
		if (!tran.edit) {
			tran.edit = true;
			this.order_status_edit.setValue(tran.orderstatusid);
		} else {
			tran.edit = false;
		}
	}

	buildHtmlAndExport(doctype) {
		this.exportingOrders = true;
		let html;
		html = '<table style="width: 100%"><thead><tr style="background: black; color: white">';
		html += '<th style="text-align:left">Tran Date</th>';
		html += '<th style="text-align:left">Customer</th>';
		html += '<th style="text-align:left">PO</th>';
		html += '<th style="text-align:center">Orderno</th>';
		html += '<th style="text-align:center">Status</th>';
		html += '<th style="text-align:center">Reason</th>';
		html += '<th style="text-align:center">Shipvia</th>';
		html += '<th style="text-align:left">Items</th>';
		html += '<th style="text-align:left">Track#</th>';
		html += '</tr></thead><tbody>';
		this.openorders.data.forEach(ord => {


			// Safely handle tracking
			const tracks = ord.tracking && ord.tracking.length ? ord.tracking.map((o: any) => { return o.trackingnumber }).join(', ') : '';
			
			// Safely handle order lines with fallback to details
			let lines = '';
			if (ord.lines && Array.isArray(ord.lines) && ord.lines.length > 0) {
				// Use ord.lines if available
				lines = ord.lines.map((o: any) => { 
					const qty = o.quantity || o.qty || '1';
					const itemCode = o.stockid || o.stkcode || 'Unknown';
					return qty + 'x ' + itemCode + ', ' +'\n'; 
				}).join('').slice(0, -2);
			} else if (ord.details) {
				// Fallback to ord.details if ord.lines is not available
				const detail = ord.details;
				const qty = detail.quantity || detail.qty || detail.ordered || '1';
				const itemCode = detail.stockid || detail.stkcode || 'Unknown';
				lines = qty + 'x ' + itemCode + '\n';
			}
			
			// Safely handle shipvia
			const shipvia = this.shipvias.find((via: any) => via.shipper_id === ord.shipvia)?.['shippername'] ?? 'N/A';
			
			html += '<tr>';
			html += `<td style='text-align: left;'>${ord.trandate || ''}</td>`;
			html += `<td style='text-align: left;'>${ord.debtorno}.${ord.branchcode}</td>`;
			html += `<td style='text-align: left;'>${ord.ponumber || ''}</td>`;
			html += `<td style='text-align: center;'>${ord.orderno}</td>`;
			html += `<td style='text-align: center;'>${ord.status || ''}</td>`;
			html += `<td style='text-align: center;'>${ord.details.cancelreason.label || ''} ${ord.details.cancelreason.notes}</td>`;
			html += `<td style='text-align: center;'>${shipvia}</td>`;
			html += `<td style='text-align: left;'>${lines}</td>`;
			html += `<td style='text-align: left;'>${tracks}</td>`;
			html += '</tr>';
		});
		html += '</tbody></table>';
		doctype === 'pdf' ? this.exportPdf(html) : this.exportXls(html);
	}

	exportPdf(html) {
		const today = new Date().toLocaleString();
		const customer = this.customerdata.customer ?? false;
		const encoded: string = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: `Canceled Orders Export - ${today}`,
			title: (customer ? `${customer.debtorno}.${customer.branchcode} ${customer.brname} - ` : '') + 'Canceled Orders Export',
			subtitle: 'Created ' + today.toLocaleString()
		}
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exportingOrders = false;
		});
	}

	exportXls(html) {
		const today = new Date().toLocaleString();
		const customer = this.customerdata.customer ?? false;
		const encoded: string = this.globalSearchService.base64encode(html);
		const data = {
			content: encoded,
			filename: `Canceled Orders Export - ${today}`,
			title: (customer ? `${customer.debtorno}.${customer.branchcode} ${customer.brname} - ` : '') + 'Canceled Orders Export',
			subtitle: 'Created ' + today.toLocaleString()
		}
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exportingOrders = false;
		});
	}

	filterShipVia() {
		this.currentFilters.selectedShipVia = this.shipvia.value || [];
		this.applyAllFilters();
	}

	filterItems() {
		this.currentFilters.selectedStatuses = this.statusSearch.value || [];
		this.applyAllFilters();
	}

	filterPrinted() {
		this.currentFilters.selectedPrinted = this.selectedPrinted;
		this.applyAllFilters();
	}

	filterItemSource() {
		this.currentFilters.selectedOrderSource = this.selectedOrderSource;
		this.applyAllFilters();
	}

	filterCustomerType(){
		this.currentFilters.selectedCustomerType = this.selectedCustomerType;
		this.applyAllFilters();
	}

	filterReason(){
		this.currentFilters.selectedReason = this.selectedReason;
		this.applyAllFilters();
	}

	filterSalesperson(trigger = true) {
		this.currentFilters.selectedSalespeople = this.salespersonRef.value || [];
		this.applyAllFilters();
	}

	searchItems() {
		this.currentFilters.itemSearchTerm = this.searchInputItems.value || '';
		this.applyAllFilters();
		// this.globalSearchService.blurInputElement(this.searchInputItems);
	}

	onKeydown(event: KeyboardEvent) {
		if (event.key === 'Enter') {
			clearTimeout(this.searchDebounce);
			this.onInput(this.searchInput.value);
		}
	}

	private debounceTimeout: any;
	onInput(event: any): void {
		clearTimeout(this.debounceTimeout);

		const inputTerm = this.searchInput.value.trim();
		const debounceDelay = 300;

		this.debounceTimeout = setTimeout(() => {
			this.currentFilters.searchTerm = inputTerm;
			this.applyAllFilters();
		}, debounceDelay);
	}

	private resetTableData(): void {
		this.currentFilters = {
			searchTerm: '',
			itemSearchTerm: '',
			selectedStatuses: [],
			selectedShipVia: [],
			selectedSalespeople: [],
			selectedCustomerType: '',
			selectedOrderSource: '',
			selectedReason: '',
			selectedPrinted: '' as any,
			warehouse: ''
		};
		this.applyAllFilters();
	}

	// Public method to clear all filters
	clearAllFilters(): void {
		// Reset all form controls
		this.searchInput.setValue('');
		this.searchInputItems.setValue('');
		this.statusSearch.setValue([]);
		this.shipvia.setValue([]);
		this.salespersonRef.setValue([]);
		this.selectedOrderSource = '';
		this.selectedCustomerType = '';
		this.selectedPrinted = '';
		
		// Reset current filters state
		this.resetTableData();
	}

	// Get the count of active filters
	getActiveFiltersCount(): number {
		let count = 0;
		
		if (this.currentFilters.searchTerm) {count++;}
		if (this.currentFilters.itemSearchTerm) {count++;}
		if (this.currentFilters.selectedStatuses.length > 0) {count++;}
		if (this.currentFilters.selectedShipVia.length > 0) {count++;}
		if (this.currentFilters.selectedSalespeople.length > 0) {count++;}
		if (this.currentFilters.selectedOrderSource) {count++;}
		if (this.currentFilters.selectedCustomerType) {count++;}
		if (this.currentFilters.selectedPrinted !== '') {count++;}
		
		return count;
	}

	// Check if any filters are active
	hasActiveFilters(): boolean {
		return this.getActiveFiltersCount() > 0;
	}

	// Get a summary of active filters
	getActiveFiltersSummary(): string[] {
		const summary: string[] = [];
		
		if (this.currentFilters.searchTerm) {
			summary.push(`Search: "${this.currentFilters.searchTerm}"`);
		}
		if (this.currentFilters.itemSearchTerm) {
			summary.push(`Item Search: "${this.currentFilters.itemSearchTerm}"`);
		}
		if (this.currentFilters.selectedStatuses.length > 0) {
			const statusNames = this.order_statuses
				?.filter(status => this.currentFilters.selectedStatuses.includes(status.order_status_id))
				.map(status => status.name) || [];
			summary.push(`Status: ${statusNames.join(', ')}`);
		}
		if (this.currentFilters.selectedShipVia.length > 0) {
			const shipViaNames = this.shipvias
				?.filter(ship => this.currentFilters.selectedShipVia.includes(ship.shipper_id))
				.map(ship => ship.shippername) || [];
			summary.push(`Ship Via: ${shipViaNames.join(', ')}`);
		}
		if (this.currentFilters.selectedSalespeople.length > 0) {
			const salespersonNames = this.salespeople
				?.filter(sp => this.currentFilters.selectedSalespeople.includes(sp.salesmancode))
				.map(sp => sp.salesmanname) || [];
			summary.push(`Salespeople: ${salespersonNames.join(', ')}`);
		}
		if (this.currentFilters.selectedOrderSource) {
			const sourceName = this.orderSources.find(s => s.value === this.currentFilters.selectedOrderSource)?.viewValue || '';
			summary.push(`Source: ${sourceName}`);
		}
		if (this.currentFilters.selectedPrinted !== '') {
			const printedText = this.currentFilters.selectedPrinted === true ? 'Yes' : 'No';
			summary.push(`Printed: ${printedText}`);
		}
		
		return summary;
	}

	private performSearch(term: string) {
		this.currentFilters.searchTerm = term.trim();
		this.applyAllFilters();
	}

	transformTotals(
		totals: Record < string, number > ,
		savedTotals: any
	): any[] {
		try {
			// Check if savedTotals is an array
			if (!Array.isArray(savedTotals)) {}

			// Map totals object into a key-value structure
			const totalsMap = new Map(Object.entries(totals));

			// Update saved_totals based on matching codes
			return savedTotals.map(entry => {
				const matchingKey = this.mapCodeToKey(entry.code); // Map code to corresponding totals key
				const newValue = matchingKey ? totalsMap.get(matchingKey) : undefined;

				if (newValue !== undefined) {
					return {
						...entry,
						text: newValue.toFixed(2), // Update with new value, formatted to two decimals
					};
				}
				return entry; // Return unchanged if no match
			});
		} catch (error) {

			// Return original savedTotals if an error occurs
			return Array.isArray(savedTotals) ? savedTotals : [];
		}
	}

	// Helper function to map codes to totals keys
	private mapCodeToKey(code: string): string | undefined {
		const codeKeyMap: Record < string, string > = {
			sub_total: 'subtotal',
			total: 'total',
			fees: 'fees',
			freight: 'freight',
			tax: 'tax',
			fet: 'fet',
		};
		return codeKeyMap[code] || undefined;
	}

	viewCustomer(debtorno: string) {
		if (!this.isPosUser) {
			this.router.navigate(['/customers/view/' + debtorno]);
		}
	}

	viewInvoicedOrder(orderno: any, content: any, cancelreason?: any) {
		this.ordersService.getInvoicedOrder(orderno).subscribe((order: any) => {
			this.orderdetails = order
			if(cancelreason){
				this.orderdetails['cancelreason'] = cancelreason;				
			}


			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

			}, (reason) => {});

			//wait for element to appear
			if (order && order.dispatch_details.status_id === '29') {
				setTimeout(() => {
					this.drawMap();
				}, 500);
			}

		});
	}

	viewOrder(orderno: any, content: any, cancelReason? : any): void {


		this.ordersService.getOrder(orderno).subscribe({

			
			next: (order: any) => {
				this.orderdetails = order;
				if(cancelReason){
					this.orderdetails.cancelreason = cancelReason;
				}

				// Update saved_totals with transformed totals
				if (order.totals && order.saved_totals) {
					this.orderdetails.saved_totals = this.transformTotals(order.totals, order.saved_totals);
				}

				// Open the modal
				this.modalService
					.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' })
					.result.then(
						() => {},
						() => {
							this.totalsArray = [];
						}
					);

				// Wait for element to appear and draw the map
				if (order?.dispatch_details?.status_id === '29') {
					setTimeout(() => this.drawMap(), 500);
				}
			},
			error: (err) => {
				console.error('Error fetching order details:', err);
			},
		});
	}

	invoiceOrder(orderno: any) {
		this.ordersService.loadSalesOrder(orderno).subscribe((result: any) => {})
		this.orderinvoice.emit(orderno);
	}

	loadOrder(tran: any) {
		const orderno = tran.orderno;
		//preorder
		switch (tran.orderstatusid) {
		case '3':
			this.ordersService.loadPreOrder(orderno, this.customerdata.customer).subscribe((result: any) => {
				this.orderinvoice.emit(false);
				this.preorderloaded.emit(result);
			});
			break;
		default:
			this.ordersService.loadSalesOrder(orderno).subscribe((result: any) => {
				this.orderinvoice.emit(false);
				this.orderloaded.emit(result);
			});
			break;
		}
	}

	loadData() {
		// Prevents duplicate calls if loadData is already in process
		if (this.newInputData) {
			if (this.subscriptionActive) {
				this.dataSubscription.unsubscribe();
			}
			this.loading = false;
		} else if (this.loading) {
			return;
		}

		this.loading = true;
		this.subscriptionActive = true;


		const search = this.customerdata?.customer?.debtorno || this.customerdata?.debtorno || '';
		// Split into separate observables with logging for each path
		let searchObs$;

		const from = `${this.todateCtrl.value.getFullYear()}-${this.fromdateCtrl.value.getMonth()+1}-${this.fromdateCtrl.value.getDate()} 00:00:00`;
		const to = `${this.todateCtrl.value.getFullYear()}-${this.todateCtrl.value.getMonth()+1}-${this.todateCtrl.value.getDate()} 23:59:59`;

		if (this.item) {
			searchObs$ = this.ordersService.getItemOrderSearch({ item: this.item, loccode: this.defaultlocation.value });
		} else if (!this.flipfilter) {
			searchObs$ = this.ordersService.getCustomerCanceledOrders(search + `&loccode=${this.defaultlocation.value}`, from, to);
		} else {
			searchObs$ = this.ordersService.getCustomerOpenOrdersFiltered({ orders: this.flipfilter });
		}

		this.dataSubscription = searchObs$.pipe(
			debounceTime(300), // Delay to prevent rapid consecutive calls
			switchMap(results => {
				return this.handleSearchResults(results);
			}),
			catchError(error => {
				return this.handleError(error);
			})
		).subscribe(() => {
			//'Subscription complete, setting loading to false');
			this.subscriptionActive = false;
			this.loading = false;
		});
	}

	private handleSearchResults(results: any) {
		if (results) {
			this.openOrderData = results;
			this.allopenOrderData = results;
			
			this.loading = false;
			this.subscriptionActive = false;
			// Apply all current filters to the newly loaded data
			this.applyAllFilters();
		}

		// Return the results (or null if nothing to return) so that switchMap can continue.
		return results;
	}

	private handleError(error: any) {
		// Optionally, show a notification to the user about the error
		this.globalSearchService.showNotification('Failed to load data.', 'danger', 'bottom', 'right');
		// Stop any loading indicators
		this.loading = false;
		// Return a fallback value (like `null` or `[]`) to prevent further processing
		return [];
	}

	ngOnChanges(changes: any) {
		if (changes.flipfilter) {
			this.newInputData = true;
			this.loadData();
		}
	}


	cancelOrder(orderno: any) {
		if (this.askForCancelReason) {
			this.pendingCancelOrderNo = orderno;
			this.modalService.open(this.confirmCancel, {
				ariaLabelledBy: 'modal-title',
				size: 'md',
			});
		} else {
			this.pendingCancelOrderNo = orderno;
			this.cancelReason = 'None Given'
			this.handleConfirmCancelOrderOnly([]);
		}
	}

	onReasonChange(): void {
		if (this.cancelReason !== 'Other') {
			this.cancelNotes = '';
		}
	}

	get reasonRequiresNote(): boolean {
		return this.cancelReason?.requires_notes === '1';
	}

	selectReason(reason: any) {
		this.cancelReason = reason;
		this.showReasonError = false;
	}

	handleConfirmCancelOrderOnly(modal: any) {
		if (!this.cancelReason || (this.cancelReason === 'Other' && !this.cancelNotes.trim())) {
			this.showReasonError = true;
			return;
		}

		this.showReasonError = false;

		// Build base payload
		const payload: any = {
			orderno: this.pendingCancelOrderNo,
			reason: this.cancelReason,
			notes: this.cancelNotes.trim(),
			timestamp: new Date().toISOString()
		};

		this.ordersService.cancelOrder(payload).subscribe((result: any) => {
			if (this.askForCancelReason) {
				modal.close();
			}

			if (!result.success && result.requires_confirmation) {
				// Prepare for second confirmation (PO linked)
				this.pendingCancelOrderNo = payload.orderno;
				this.purchaseOrderLinked = result.purchase_orderno;

				// Include flag for second submission
				this.pendingCancelPayload = {
					...payload,
					cancelPo: true
				};
				if (this.askForCancelReason) {
					this.modalService.open(this.confirmCancelPoRef, {
						ariaLabelledBy: 'modal-title',
						size: 'md'
					});
				}

				return;
			}

			this.handleCancelResponse(result, this.pendingCancelOrderNo);
		});
	}

	confirmCancelPo(forceCancelPo: boolean, modal: any) {
		const orderno = this.pendingCancelOrderNo;
		const force = forceCancelPo ? 'yes' : 'no';

		this.pendingCancelPayload.cancelPo = forceCancelPo;
		const payload = this.pendingCancelPayload;

		this.ordersService.cancelOrderWithPo(payload, force).subscribe((results: any) => {
			modal.close();
			this.handleCancelResponse(results, orderno);
		});
	}

	cancelModal(modal: any) {
		modal.dismiss();
	}


	private handleCancelResponse(results: any, orderno: any) {

		this.cancel.emit(true);
		this.reloadCustomer.emit(true);
		this.cart_updated.emit(results);

		const data = {
			cancel: true,
			editing: false,
			neworder: false,
			orderno: orderno,
			user: this.user
		};

		this.omsService.sendOrderCheckUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
		this.omsService.sendOrderPickUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
		this.loadData();
	}


	setDelivered(orderno: any) {
		this.ordersService.setDelivered({ orderno: orderno }).subscribe(async (results: any) => {
			this.loadData()
		})
	}

	updatePick(orderno: any) {
		//needs callback to have customer only
		this.ordersService.updateOrderToPicked({ orderno: orderno }).subscribe(async (results: any) => {

			const data = {
				user: this.user
			};

			this.omsService.sendOrderCheckUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
			this.loadData()
		})
	}

	drawMap() {

		this.globalSearchService.hideSideBar();
		const coordinates = [];
		const columndata = this.orderdetails.dispatch_details;

		const home: any = { lat: columndata.clat, lng: columndata.clng }
		const truckpos = { lat: columndata.lastlat, lng: columndata.lastlng }
		const counter = 0;
		const trucklat = new google.maps.LatLng(truckpos);
		const lines = [trucklat];
		lines.push(home)

		const regex = /<br\s*[\/]?>/gi;
		//<br />
		const name = columndata.address.replace(regex, '\n');
		const m = new google.maps.Marker({
			position: home,
			title: name,
			optimized: true,
			animation: google.maps.Animation.DROP,
			label: {
				text: name,
				color: '#000',
				fontSize: '14px',
				fontWeight: 'bold'
			}
		}, );

		coordinates.push(m);

		const c = new google.maps.Marker({
			position: trucklat,
			title: columndata.truck_name,
			optimized: true,
			animation: google.maps.Animation.DROP,
			label: {
				text: columndata.truck_name,
				color: '#000',
				fontSize: '14px',
				fontWeight: 'bold'
			}
		});

		coordinates.push(c);

		const mapOptions = {
			zoom: 11,
			center: home,
			scrollwheel: false, //we disable de scroll over the map, it is a really annoing when you scroll through page
			styles: [{
				'featureType': 'water',
				'stylers': [{
					'saturation': 43
				}, {
					'lightness': -11
				}, {
					'hue': '#0088ff'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.fill',
				'stylers': [{
					'hue': '#ff0000'
				}, {
					'saturation': -100
				}, {
					'lightness': 99
				}]
			}, {
				'featureType': 'road',
				'elementType': 'geometry.stroke',
				'stylers': [{
					'color': '#808080'
				}, {
					'lightness': 54
				}]
			}, {
				'featureType': 'landscape.man_made',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ece2d9'
				}]
			}, {
				'featureType': 'poi.park',
				'elementType': 'geometry.fill',
				'stylers': [{
					'color': '#ccdca1'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.fill',
				'stylers': [{
					'color': '#767676'
				}]
			}, {
				'featureType': 'road',
				'elementType': 'labels.text.stroke',
				'stylers': [{
					'color': '#ffffff'
				}]
			}, {
				'featureType': 'poi',
				'stylers': [{
					'visibility': 'off'
				}]
			}, {
				'featureType': 'landscape.natural',
				'elementType': 'geometry.fill',
				'stylers': [{
					'visibility': 'on'
				}, {
					'color': '#b8cb93'
				}]
			}, {
				'featureType': 'poi.park',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.sports_complex',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.medical',
				'stylers': [{
					'visibility': 'on'
				}]
			}, {
				'featureType': 'poi.business',
				'stylers': [{
					'visibility': 'simplified'
				}]
			}]

		};

		this.map = new google.maps.Map(document.getElementById('map'), mapOptions);

		coordinates.forEach((item: any) => {
			item.setMap(this.map);
		});

		const lineSymbol = {
			path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
		};

		const pathTo = new google.maps.Polyline({
			path: lines,
			geodesic: true,
			strokeColor: '#F1575A',
			strokeOpacity: 1.0,
			strokeWeight: 2,
			icons: [{
				icon: lineSymbol,
				offset: '100%'
			}],
		});

		pathTo.setMap(this.map);
	}

	getTotalQuantity(): number {
		if (!this.podetails || !this.podetails.polines) {return 0;}
		return this.podetails.polines.reduce((total, item) => parseFloat(total) + parseFloat(item.quantityord), 0);
	}

	getTotalValue(): number {
		if (!this.podetails || !this.podetails.polines) {return 0;}
		return this.podetails.polines.reduce((total, item) => parseFloat(total) + (parseFloat(item.unitprice) * parseFloat(item.quantityord)), 0);
	}

	async copyToClipboard (text: string): Promise < void > {
		try {
			await navigator.clipboard.writeText(text);
		} catch (err) {}
	}

	back(): void {
		this.location.back()
	}

	announceSortChange(event: any) {
		// alert(JSON.stringify(this.sort));
		// alert(JSON.stringify(event))

	}
	//merge stuff
	mergeList: any[] = []; // List to hold selected orders

	mergeOrders(): void {
		if (this.mergeList.length === 0) {
			return;
		}

		// Group orders by debtorno
		const groupedOrders = this.mergeList.reduce((acc, order) => {
			if (!acc[order.debtorno]) {
				acc[order.debtorno] = [];
			}
			acc[order.debtorno].push(order.orderno);
			return acc;
		}, {} as {
			[key: string]: string[]
		});

		const payload = Object.keys(groupedOrders).map(debtorno => ({
			debtorno,
			orders: groupedOrders[debtorno]
		}));

		this.ordersService.mergeOrders(payload).subscribe((r: any) => {
			if (r.success) {
				this.mergeList = [];
				this.loadData();
			} else {
				this.globalSearchService.showNotification(r.error, 'danger', 'bottom', 'right');
			}
		});
	}

	isSelected(order: any): boolean {
		return this.mergeList.some(o => o.orderno === order.orderno);
	}

	toggleOrderSelection(event: any, order: any): void {
		if (event.checked) {
			if (!this.isSelected(order)) {
				this.mergeList.push(order);
			}
		} else {
			this.mergeList = this.mergeList.filter(o => o.orderno !== order.orderno);
		}
	}

	isAllSelected(): boolean {
		return this.openorders.length && this.mergeList.length === this.openorders.length;
	}

	isSomeSelected(): boolean {
		return this.mergeList.length > 0 && !this.isAllSelected();
	}

	selectAll(event: any): void {
		if (event.checked) {
			this.mergeList = [...this.openorders];
		} else {
			this.mergeList = [];
		}
	}

	trackByOrderNo(index: number, order: any): any {
		return order.orderno;
	}

	getTrackingColor(shipper: string | null | undefined): string {
		if (!shipper || typeof shipper !== 'string') {
			return 'Default';
		}

		switch (shipper.toLowerCase()) {
		case 'fedex':
			return 'FedEx';
		case 'ups':
			return 'UPS';
		case 'usps':
			return 'USPS';
		case 'dhl':
			return 'DHL';
		default:
			return 'Default';
		}
	}


	applicableTracking(tran: any) {
		return tran.tracking?.some(t => t.trackingnumber)
	}

	toggleMerging(): void {
		this.isMerging = !this.isMerging;
		if (!this.isMerging) {
			this.mergeList = [];
		}
	}
}